import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    accounts: {
      selectIds: [],
      filters: {},
      selectId: false
    }
  },
  mutations: {
    SET_ACCOUNT_SELECT_IDS (store, ids) {
      store.accounts.selectIds = ids
    },
    SET_ACCOUNT_SELECT_ID (store, id) {
      store.accounts.selectId = id
    },
    SET_ACCOUNT_FILTERS (store, filters) {
      store.accounts.filters = filters
    }
  },
  getters: {
    getAccounts: (store, getters) => {
      return store.accounts.selectIds.map((id) => {
        return getters['entities/accounts/find'](id)
      })
    },
    getAccountsFilters: (store, getters) => {
      return store.accounts.filters
    },
    getAccount: (store, getters) => {
      const data = getters['entities/accounts/find'](store.accounts.selectId)
      return data ? {
        ...data,
        sampleRhevolut: ['5dd2fc3268b4b40b4c36f183'].includes(store.accounts.selectId)
      } : {}
    }
  },
  actions: {
    /*
    selectAccounts
    */
    selectAccounts ({commit, dispatch, getters, state}, filters) {
      return dispatch('getAccounts', filters)
      .then((response) => {
        commit('SET_ACCOUNT_FILTERS', filters)
        commit('SET_ACCOUNT_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectAccounts
    */
    refreshSelectAccounts ({commit, dispatch, getters, state}) {
      return dispatch('selectAccounts', getters.getAccountsFilters)
    },
    /*
    selectAccount
    */
    selectAccount ({commit, dispatch, getters, state}, id) {
      return dispatch('getAccountById', id)
      .then((response) => {
        commit('SET_ACCOUNT_SELECT_ID', response._id)
        return Promise.all([
          dispatch('setProfile'), // set profile
          dispatch('setIntegrationSummaries'), // set integrations summaries
          dispatch('setAccountResourceAvailability') // ResourceAvailability
        ])
        .then(_ => response)
      })
    },
    /*
    getAccounts
    */
    getAccounts ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts`, {params: filters})
      .then((response) => {
        return dispatch('entities/accounts/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.accounts || []
      })
    },
    /*
    getAccountById
    */
    getAccountById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${id}`)
      .then((response) => {
        return dispatch('entities/accounts/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.accounts[0]
      })
    },
    /*
    updateAccount
    */
    updateAccount ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/accounts/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.accounts[0]
      })
    },
    /*
    updateAccount
    */
    updateAccountSlug ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${data._id}/account-slug`, data)
      .then((response) => {
        return dispatch('entities/accounts/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.accounts[0]
      })
    },
    /*
    updateCurrentAccount
    */
    updateCurrentAccount ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return dispatch('updateAccount', {
        ...data,
        _id: getters.getAccount._id
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Account.js